<div class="lvi-content">
    <div class="avatar" [nSelector]="{liste: liste, item: data, isNotSelectable: data.debit.valueOf().toString() !== 'COLLAB' }">
        <i class="material-icons-outlined">credit_card</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label">{{ data.mccLibelle }}</a>
        </div>
        <ul class="lvi-attrs">
            <li><strong [translate]="'opeCarte.liste.tag.carte'"></strong> {{ data.numCarte }}  </li>
            <li><strong [translate]="'opeCarte.liste.tag.date'"></strong> {{ data.dateVente | date:'shortDate' }}</li>
            <li><strong [translate]="'opeCarte.liste.tag.achat'"></strong> {{ data.montantAchat | number:'1.2-2' }} {{ data.deviseAchat }}</li>
            <li><strong [translate]="'opeCarte.liste.tag.commercant'"></strong> {{ data.enseigne }} ({{ data.localite }})</li>
            <li><strong [translate]="'opeCarte.liste.tag.restant'"></strong> {{ data.montantRestant | number:'1.2-2' }} {{ data.deviseAchat }}</li>
            <li *ngIf="data.ndfAssocies"><strong [translate]="'opeCarte.liste.tag.ndfAssocies'"></strong>
                <ng-container *ngFor="let ndf of ndfAssociesParsed; let isLast = last">
                    <span (click)="openNdf(ndf.id)" style="cursor:pointer;">
                        {{ ndf.libelle }}
                        <mat-icon color="primary" style="font-size:1.1em; cursor:pointer;">open_in_new</mat-icon>
                    </span>
                    <span *ngIf="!isLast">, </span>
                </ng-container>
            </li>
        </ul>
    </div>
    <div class="info">
        <div>
            <etat-operation [etatOperationCode]="data.etatOperation"></etat-operation>
            <div class="text-end text-secondary fw-bold">
                {{ data.montantReglement | number:'1.2-2' }} {{ data.deviseReglement }}
            </div>
        </div>
    </div>
</div>
